import BrowseChannels from "discourse/plugins/chat/discourse/components/browse-channels";

export default <template><BrowseChannels @currentTab="all" /></template>
